import { render, staticRenderFns } from "./MListSimple.vue?vue&type=template&id=7e5e7185&"
import script from "./MListSimple.vue?vue&type=script&lang=js&"
export * from "./MListSimple.vue?vue&type=script&lang=js&"
import style0 from "./MListSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports